import classnames from 'classnames'
import compose from 'lodash/flowRight'
import * as React from 'react'
import type {Ref} from 'react'

import {withOneLineProp} from '../../../../contexts/oneLine'
import type {BuildLineLayout} from '../../../../types'
import RowGroup from '../../Grid/RowGroup'
import {withVisibility} from '../../Visible/Visible.hocs'

import BuildLayout from './BuildLayout/BuildLayout'

import styles from './Build.css'

type OwnProps = {
  alwaysShowLineBorders?: boolean
  commentText?: string
  hasBranch?: boolean
  hideBorders?: boolean
  wrapped?: boolean
  className?: string
  outerRef?: Ref<HTMLDivElement>
  isVisible?: boolean
}
type DefaultProps = {
  alwaysShowLineBorders: boolean
  hasBranch: boolean
}
type Props = OwnProps &
  DefaultProps & {
    buildLineLayout: BuildLineLayout
    oneLine: boolean
  }

class BuildPlaceholder extends React.Component<Props> {
  static defaultProps = {
    alwaysShowLineBorders: false,
    hasBranch: false,
  }

  getPladeholderLoader = (animated: boolean | undefined) => {
    const {
      hasBranch,
      oneLine,
      buildLineLayout: {showAgent, showBranch, showPath},
      outerRef,
    } = this.props
    return (
      <>
        <div
          className={classnames(styles.number, styles.placeholder, {[styles.animated]: animated})}
          ref={outerRef}
        >
          &nbsp;
        </div>
        {showBranch === true && oneLine && (
          <div
            className={classnames(styles.branchPath, styles.placeholder, {
              [styles.animated]: animated,
            })}
          >
            &nbsp;
          </div>
        )}
        {(showBranch === true || showPath) && (
          <div
            className={classnames(styles.branchPath, {
              [styles.noBranch]: !hasBranch,
            })}
          >
            {showBranch === true && (
              <div
                className={classnames(styles.branch, styles.placeholder, {
                  [styles.animated]: animated,
                })}
              >
                &nbsp;
              </div>
            )}
          </div>
        )}
        <div
          className={classnames(styles.status, styles.placeholder, {[styles.animated]: animated})}
        >
          &nbsp;
        </div>
        <div
          className={classnames(styles.changes, styles.placeholder, {[styles.animated]: animated})}
        >
          &nbsp;
        </div>
        {showAgent === true && (
          <div
            className={classnames(styles.agent, styles.placeholder, {[styles.animated]: animated})}
          >
            &nbsp;
          </div>
        )}
        <div
          className={classnames(styles.duration, styles.placeholder, {
            [styles.animated]: animated,
          })}
        >
          &nbsp;
        </div>
        <div
          className={classnames(styles.icons, styles.placeholder, {[styles.animated]: animated})}
        >
          &nbsp;
        </div>
      </>
    )
  }

  render() {
    const {
      alwaysShowLineBorders,
      hideBorders,
      wrapped,
      className,
      oneLine,
      buildLineLayout: {showPath, showBranch},
      hasBranch,
      isVisible,
    } = this.props
    const classes = classnames(styles.build, className, {
      [styles.oneLine]: oneLine,
      [styles.withoutPath]: !showPath,
      [styles.wrapped]: wrapped,
    })
    return (
      <RowGroup span={3}>
        <BuildLayout
          className={classes}
          hideBorders={hideBorders}
          alwaysShowLineBorders={alwaysShowLineBorders}
        >
          <div className={styles.notCommentWrapper}>{this.getPladeholderLoader(isVisible)}</div>
          <div
            className={classnames(styles.description, {
              [styles.compactDescription]:
                !oneLine && (!hasBranch || showBranch !== true) && !showPath,
            })}
          />
          <div className={styles.emptyLine} />
        </BuildLayout>
      </RowGroup>
    )
  }
}

export default compose(
  withVisibility(false),
  React.memo,
  withOneLineProp,
)(BuildPlaceholder) as React.ComponentType<OwnProps>
